import React, { useState, useEffect } from 'react';
import api from '../api';

const ACTIVITIES = ['Course à pied', 'Musculation', 'Yoga', 'Natation', 'Vélo', 'Marche', 'HIIT', 'Pilates', 'Danse', 'Football', 'Tennis', 'Autre'];

export default function SportPage() {
  const [sessions, setSessions] = useState([]);
  const [stats, setStats] = useState({ week: { sessions: 0, total_min: 0 }, month: { sessions: 0, total_min: 0 } });
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ activity: '', session_date: new Date().toISOString().split('T')[0], start_time: '', duration_min: 30, intensity: 'modere', notes: '' });

  const load = async () => {
    try {
      const [sessRes, statsRes] = await Promise.all([api.get('/sport'), api.get('/sport/stats')]);
      setSessions(sessRes.data);
      setStats(statsRes.data);
    } catch {}
  };

  useEffect(() => { load(); }, []);

  const addSession = async (e) => {
    e.preventDefault();
    await api.post('/sport', form);
    setShowModal(false);
    setForm({ activity: '', session_date: new Date().toISOString().split('T')[0], start_time: '', duration_min: 30, intensity: 'modere', notes: '' });
    load();
  };

  const toggleDone = async (id) => {
    await api.put(`/sport/${id}/toggle`);
    load();
  };

  const deleteSession = async (id) => {
    await api.delete(`/sport/${id}`);
    load();
  };

  const intensityLabel = { leger: 'Léger', modere: 'Modéré', intense: 'Intense' };
  const intensityColor = { leger: 'var(--success)', modere: 'var(--warning)', intense: 'var(--danger)' };

  return (
    <div>
      <div className="page-header page-header-row">
        <div>
          <h1>Sport & Bien-être</h1>
          <p>Planifiez et suivez vos séances</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Nouvelle séance</button>
      </div>

      <div className="sport-stats">
        <div className="sport-stat-card">
          <div className="sport-stat-value">{stats.week.sessions}</div>
          <div className="sport-stat-label">Séances cette semaine</div>
        </div>
        <div className="sport-stat-card">
          <div className="sport-stat-value">{stats.week.total_min}<span style={{ fontSize: '0.8rem', fontWeight: 400 }}> min</span></div>
          <div className="sport-stat-label">Temps cette semaine</div>
        </div>
        <div className="sport-stat-card">
          <div className="sport-stat-value">{stats.month.sessions}</div>
          <div className="sport-stat-label">Séances ce mois</div>
        </div>
        <div className="sport-stat-card">
          <div className="sport-stat-value">{Math.round(stats.month.total_min / 60)}<span style={{ fontSize: '0.8rem', fontWeight: 400 }}>h</span></div>
          <div className="sport-stat-label">Heures ce mois</div>
        </div>
      </div>

      {sessions.length === 0 ? (
        <div className="empty-state">
          <div className="empty-emoji">&#127947;</div>
          <p>Aucune séance planifiée. Ajoutez votre première séance de sport !</p>
        </div>
      ) : (
        <div className="sport-list">
          {sessions.map(s => (
            <div key={s.id} className={`sport-item ${s.completed ? 'done' : ''}`}>
              <div className="sport-emoji" style={{ cursor: 'pointer' }} onClick={() => toggleDone(s.id)}>
                {s.completed ? '&#9989;' : '&#9898;'}
              </div>
              <div className="sport-info">
                <div className="sport-activity">{s.activity}</div>
                <div className="sport-details">
                  <span>{new Date(s.session_date + 'T00:00').toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })}</span>
                  {s.start_time && <span>{s.start_time.slice(0, 5)}</span>}
                  {s.duration_min && <span>{s.duration_min} min</span>}
                  <span style={{ color: intensityColor[s.intensity], fontWeight: 700 }}>{intensityLabel[s.intensity]}</span>
                </div>
              </div>
              <button className="btn-ghost" onClick={() => deleteSession(s.id)}>&#128465;</button>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Planifier une séance</h2>
            <form onSubmit={addSession}>
              <div className="form-group">
                <label>Activité</label>
                <select className="form-input" value={form.activity} onChange={e => setForm({ ...form, activity: e.target.value })} required>
                  <option value="">Choisir...</option>
                  {ACTIVITIES.map(a => <option key={a} value={a}>{a}</option>)}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Date</label>
                  <input className="form-input" type="date" value={form.session_date} onChange={e => setForm({ ...form, session_date: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label>Heure</label>
                  <input className="form-input" type="time" value={form.start_time} onChange={e => setForm({ ...form, start_time: e.target.value })} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Durée (min)</label>
                  <input className="form-input" type="number" min="5" max="300" value={form.duration_min} onChange={e => setForm({ ...form, duration_min: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Intensité</label>
                  <select className="form-input" value={form.intensity} onChange={e => setForm({ ...form, intensity: e.target.value })}>
                    <option value="leger">Léger</option>
                    <option value="modere">Modéré</option>
                    <option value="intense">Intense</option>
                  </select>
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
                <button type="submit" className="btn btn-primary">Planifier</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
